import React, { Component } from 'react'
import styled from '@emotion/styled'
import * as firebase from "firebase/app";
import "firebase/firestore"

const Container = styled.div`
padding: 20px;
`

const ListItem = styled.div`
padding: 20px;
`

export default class ProjectList extends Component {
  store = null;
  state = {
    projects: [],
    loading: true
  }
  componentDidMount() {
    this.store = firebase.firestore();
    this.store.collection("projects").get().then((querySnapshot) => {
      const projects = [];
      querySnapshot.forEach((doc) => {
          console.log(`${doc.id} => ${doc.data()}`);
          projects.push({
            id: doc.id,
            data: doc.data()
          });
      });
      this.setState({
        projects,
        loading: false
      });
    });
  }
  render() {
    return (
      <Container>
        <h4>Project List</h4>
        <div>
          {this.state.projects.map(project => {
            return <ListItem key={project.id}>{project.data.text}</ListItem>
          })}
        </div>
      </Container>
    )
  }
}
